export default "__VITE_ASSET__ZHWcKixU__"